import {createApp} from 'vue';
import App from './App.vue';
import router from './router.js';
import VTooltip from 'v-tooltip';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueCookies from 'vue3-cookies';
import 'bootstrap/dist/js/bootstrap.js';
import store from './store/index.js';
import 'bootstrap/dist/css/bootstrap.min.css';

const app = createApp(App);
app.use(VTooltip)
.use(VueCookies)
.use(router)
.use(VueAxios, axios)
.use(store)
.mount('#app');

